/**
 * Which building model belongs to which site: the ONLY site-to-asset registry.
 *
 * Every reader asks here -- the building view, and the Overview deciding
 * whether 3D is available at all. A second registry is how a site gets
 * another site's building: the 1.x screen imported NoMad's file directly,
 * so any site that reached `/twin` was drawn as Hotel NoMad.
 *
 * Kept free of three.js and of the asset's CONTENT: a `?url` import is a
 * string, so the main bundle can read this without pulling the 3D chunk or
 * 40 KB of geometry. The asset is fetched by `loadGeometry`, which checks
 * that the file really is this site's, in schema 2.x.
 */
import sgNomad01Url from './assets/sg-nomad-01.geometry.v2.json?url';

export interface TwinAssetRef {
  /** The site the asset was registered for. `loadGeometry` checks the file
   *  says the same. */
  readonly site: string;
  readonly url: string;
}

const REGISTRY: ReadonlyMap<string, string> = new Map([['sg-nomad-01', sgNomad01Url]]);

/** The building model for this site, or null when there is none. */
export function twinAssetFor(siteId: string | null | undefined): TwinAssetRef | null {
  if (!siteId) return null;
  const url = REGISTRY.get(siteId);
  return url ? { site: siteId, url } : null;
}
